export default "__VITE_ASSET__DHbAk2ch__"